import React from 'react'
import { Form, Input, Row, Col, Divider, Button, Table, notification } from 'antd'
import Search from '../../components/Search'

const PanelRelations = ({ desc, setDesc, asc, setAsc, data }) => {
    const [currentIdAsc, setCurrentIdAsc] = React.useState(null)
    const [currentNameAsc, setCurrentNameAsc] = React.useState(null)
    const [currentSKUAsc, setCurrentSKUAsc] = React.useState(null)
    const [currentAmountAsc, setCurrentAmountAsc] = React.useState(null)

    const [currentIdDesc, setCurrentIdDesc] = React.useState(null)
    const [currentNameDesc, setCurrentNameDesc] = React.useState(null)
    const [currentSKUDesc, setCurrentSKUDesc] = React.useState(null)
    const [currentAmountDesc, setCurrentAmountDesc] = React.useState(null)

    const onKeyPressNumbers = event => {
        if (!/[0-9]/.test(event.key)) {
            event.preventDefault()
        }
    }

    const columnsDesc = [
        {
            title: 'SKU',
            dataIndex: 'sku',
            key: 'sku',
        },
        {
            title: 'Producto',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Cantidad',
            dataIndex: 'amount',
            key: 'amount',
        },
        {
            title: 'Acciones',
            dataIndex: 'actions',
            key: 'actions',
            render: (label, record) => {
                return (
                    <Button
                        type="primary"
                        shape="circle"
                        icon="delete"
                        size="small"
                        style={{ margin: 5 }}
                        onClick={() => {
                            const newData = desc.filter(f => f.key !== record.key)
                            setDesc(newData)
                        }}
                    />
                )
            },
        },
    ]

    const columnsAsc = [
        {
            title: 'SKU',
            dataIndex: 'sku',
            key: 'sku',
        },
        {
            title: 'Producto',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Cantidad',
            dataIndex: 'amount',
            key: 'amount',
        },
        {
            title: 'Acciones',
            dataIndex: 'actions',
            key: 'actions',
            render: (label, record) => {
                return (
                    <Button
                        type="primary"
                        shape="circle"
                        icon="delete"
                        size="small"
                        style={{ margin: 5 }}
                        onClick={() => {
                            const newData = asc.filter(f => f.key !== record.key)
                            setAsc(newData)
                        }}
                    />
                )
            },
        },
    ]

    return (
        <>
            <Row gutter={24}>
                <Col lg={12} md={12} sm={12}>
                    <p style={{ textAlign: 'right' }}>
                        <b>SKU del producto:</b> {data.sku}
                    </p>
                </Col>
                <Col lg={12} md={12} sm={12}>
                    <p style={{ textAlign: 'left' }}>
                        <b> Nombre del producto:</b> {data.name}
                    </p>
                </Col>
            </Row>

            <Row gutter={24}>
                <Col lg={12} md={24} sm={24}>
                    <Divider>Productos padres</Divider>
                    <Row gutter={24} style={{ display: 'flex', alignItems: 'end' }}>
                        <Col lg={15} md={15} sm={15}>
                            <Form.Item label="Producto padre ">
                                <Search
                                    value={currentIdAsc}
                                    placeholder="Busca una producto"
                                    onSearch={value => `/api/only/products?filter[q]=${value}`}
                                    onChange={(key, value) => {
                                        setCurrentIdAsc(key)
                                        setCurrentNameAsc(value.name)
                                        setCurrentSKUAsc(value.sku)
                                    }}
                                />
                            </Form.Item>
                        </Col>

                        <Col lg={7} md={7} sm={7}>
                            <Form.Item label="Cantidad en hijos" hasFeedback>
                                <Input
                                    style={{ width: '100%' }}
                                    onKeyPress={onKeyPressNumbers}
                                    placeholder="Escribe la cantidad"
                                    value={currentAmountAsc}
                                    onChange={e => {
                                        setCurrentAmountAsc(e.target.value)
                                    }}
                                />
                            </Form.Item>
                        </Col>

                        <Col lg={2} md={2} sm={2}>
                            <Form.Item hasFeedback>
                                <Button
                                    type="primary"
                                    shape="circle"
                                    icon="plus"
                                    disabled={!currentIdAsc || !currentNameAsc || !currentAmountAsc}
                                    onClick={() => {
                                        if (!asc.findIndex(f => f.key === currentIdAsc)) {
                                            notification.error({
                                                message: 'El producto ya se encuentra listado.',
                                            })
                                        } else {
                                            const newData = [
                                                ...asc,
                                                {
                                                    key: currentIdAsc,
                                                    name: currentNameAsc,
                                                    sku: currentSKUAsc,
                                                    amount: currentAmountAsc,
                                                },
                                            ]
                                            setAsc(newData)
                                            setCurrentIdAsc(null)
                                            setCurrentNameAsc(null)
                                            setCurrentAmountAsc(null)
                                            setCurrentSKUAsc(null)
                                        }
                                    }}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Table dataSource={asc} columns={columnsAsc} />
                </Col>
                <Col lg={12} md={24} sm={24}>
                    <Divider>Productos hijos</Divider>
                    <Row gutter={24} style={{ display: 'flex', alignItems: 'end' }}>
                        <Col lg={15} md={15} sm={15}>
                            <Form.Item label="Producto hijo">
                                <Search
                                    value={currentIdDesc}
                                    placeholder="Busca una producto"
                                    onSearch={value => `/api/only/products?filter[q]=${value}`}
                                    onChange={(key, value) => {
                                        setCurrentIdDesc(key)
                                        setCurrentNameDesc(value.name)
                                        setCurrentSKUDesc(value.sku)
                                    }}
                                />
                            </Form.Item>
                        </Col>
                        <Col lg={7} md={7} sm={7}>
                            <Form.Item label="Cantidad en hijos" hasFeedback>
                                <Input
                                    style={{ width: '100%' }}
                                    onKeyPress={onKeyPressNumbers}
                                    placeholder="Escribe la cantidad"
                                    value={currentAmountDesc}
                                    onChange={e => {
                                        setCurrentAmountDesc(e.target.value)
                                    }}
                                />
                            </Form.Item>
                        </Col>
                        <Col lg={2} md={2} sm={2}>
                            <Form.Item hasFeedback>
                                <Button
                                    type="primary"
                                    shape="circle"
                                    icon="plus"
                                    disabled={!currentIdDesc || !currentNameDesc || !currentAmountDesc}
                                    onClick={() => {
                                        if (!desc.findIndex(f => f.key === currentIdDesc)) {
                                            notification.error({
                                                message: 'El producto ya se encuentra listado.',
                                            })
                                        } else {
                                            const newData = [
                                                ...desc,
                                                {
                                                    key: currentIdDesc,
                                                    name: currentNameDesc,
                                                    sku: currentSKUDesc,
                                                    amount: currentAmountDesc,
                                                },
                                            ]
                                            setDesc(newData)
                                            setCurrentIdDesc(null)
                                            setCurrentNameDesc(null)
                                            setCurrentAmountDesc(null)
                                            setCurrentSKUDesc(null)
                                        }
                                    }}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Table dataSource={desc} columns={columnsDesc} />
                </Col>
            </Row>
        </>
    )
}

export default PanelRelations
